import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 2.5a9.5 9.5 0 1 1-4.839 17.677l-3.88 1.292a.594.594 0 0 1-.75-.75l1.294-3.879A9.5 9.5 0 0 1 12 2.5Zm0 1.187a8.312 8.312 0 0 0-7.024 12.76.594.594 0 0 1 .062.506l-1.004 3.015 3.016-1.005a.594.594 0 0 1 .504.062 8.312 8.312 0 1 0 4.447-15.338ZM8.693 7.255c.156 0 .311 0 .447.006.142.01.334-.06.526.43.194.505.662 1.749.72 1.873.06.125.098.274.022.44-.079.17-.119.275-.235.42-.117.149-.245.33-.352.44-.116.128-.238.262-.1.515.133.25.605 1.078 1.298 1.744.895.86 1.646 1.127 1.881 1.252.233.126.37.102.505-.063.138-.166.583-.735.74-.988.155-.25.312-.211.526-.125.214.083 1.364.691 1.597.816.235.128.392.192.449.297.06.107.06.61-.134 1.197-.196.589-1.128 1.127-1.578 1.2-.404.062-.915.088-1.474-.103-.453-.152-.897-.33-1.331-.53-2.346-1.093-3.877-3.634-3.994-3.8-.117-.167-.955-1.366-.955-2.606 0-1.237.604-1.848.817-2.098a.831.831 0 0 1 .625-.317Z"
    }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }